import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { Menu } from '@mui/icons-material';
import { Box, Tab, Tabs } from '@mui/material';
import Service from '../../../../util/Service';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export default function BPMCRUDPageDialog(props) {
  const {open, setOpen, processo} = props;
  const [value, setValue] = React.useState(0);

  const [formCode, setFormCode] = React.useState('');
  const [tableCode, setTableCode] = React.useState('');

  React.useEffect(() =>{
    if( open){        
        buscaPaginasModelo();
    }
  }, [open]);

  function buscaPaginasModelo(){
    Service.GET("/api/security/template/montaUseCaseFromBpmId/"+processo.id).then( r =>{
        console.log( r );
        if( r.success === true){
            setFormCode( r.form );
            setTableCode( r.table );
        }

    })
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        slots={{
          transition: Transition,
        }}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <Menu />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {processo?(processo.nome + " - "+processo.titulo): "ProcessoBPM online"}
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs 
                    value={value} onChange={handleChange} 
                    aria-label="Paginas CRUD"
                    variant="fullWidth"
                >
                <Tab label="Pagina Listagem em tabela" {...a11yProps(0)} />
                <Tab label="Pagina Formulario edição e novo registro" {...a11yProps(1)} />                
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <div className='pd-code' style={{maxHeight: "700px"}}>{tableCode}</div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <div className='pd-code' style={{maxHeight: "700px"}}>{formCode}</div>
            </CustomTabPanel>            
        </Box>
      </Dialog>
  );
}
